import React from "react";
import PropTypes from "prop-types";

import "../../../styles/BoatList.scss";
import "./Reschedule.scss";
import NavBar from "../../common/forms/NavbarCopy";
import { getRescheduleHistory } from "../../../services/RescheduleService";
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavbarText, Modal, ModalHeader, Row, Col, Button } from "reactstrap";
import { Select, Skeleton } from "antd";
import { getLocalStorageValues } from "../../../services/boat";
import { FaArrowCircleRight } from "react-icons/fa";
import { BsArrowLeft } from "react-icons/bs";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import { subDirectory } from "../../../config.json";
import { SkRescheduleHistoryCard } from "../../common/skeleton/subcatCardSkeleton";
const dateFormat = "YYYY/MM/DD";

class RescheduledHistory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Rescheduledata: [],
      currentdate: moment(new Date()).format("DD-MM-YYYY"),
      isReschedulingLoading: true,
      isReschedulingAvailable: false,
    };
  }

  componentDidMount = async () => {
    await this.getRescheduleHistory();
  };

  getRescheduleHistory = async () => {
    let data = {
      QueryType: "PublicReScheduleHistory",
      ServiceType: "1",
      UserId: getLocalStorageValues("UserId"),
      BookingDate: this.state.currentdate,
      BookingId: "0",
      BoatHouseId: "0",
    };
    const res = await getRescheduleHistory(data);
    if (res?.data?.Table?.length > 0) {
      this.setState({ Rescheduledata: res.data.Table, isReschedulingLoading: false, isReschedulingAvailable: true });
    } else {
      this.setState({ Rescheduledata: [], isReschedulingLoading: false, isReschedulingAvailable: false });
    }
    await this.setState({ loading: false });
  };

  render() {
    const { Option } = Select;
    const { isReschedulingLoading, isReschedulingAvailable } = this.state;
    return (
      <div className="boatlistmainblock reschedule-history">
        <NavBar {...this.props} />

        <div className="Boatrescheduleblock">
          <div className="boatschedulecardblock">
            <div className="d-flex justify-content-between flex-wrap mt-3  mx-auto"
            style={{width:"90%"}}>
              <div
                className="d-flex align-items-center "
                style={{ fontSize: "16px", color: "white", cursor: "pointer" }}
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <BsArrowLeft className="mr-2" />
                Back
              </div>
              <div className="d-flex justify-content-center" style={{marginRight:"10%"}}>
                <div className="headofreschedule "> Reschedule History</div>
              </div>
              <div className="">
                {/* <Link to={`${subDirectory}/RescheduleHistory`}>
                  <div className="headofreschedulehis">
                    Reschedule History <BsArrowRight className="ml-2" />
                  </div>
                </Link> */}
              </div>
            </div>
            {/* <div
              className="d-flex align-items-center "
              style={{ fontSize: "16px", color: "white", cursor: "pointer" }}
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              <BsArrowLeft className="mr-2" />
              Back
            </div> */}
            {/* <div className="headofreschedule d-flex justify-content-center">Reschedule History</div> */}

            {isReschedulingLoading && (
              <Row className="rsrow1">
                <div className="reschedulecard-history mx-auto " style={{ width: "70%" }}>
                  {/* <SkRescheduleHistoryCard /> */}
                  <Skeleton loading={isReschedulingLoading} active />
                </div>
              </Row>
            )}
            <>
              <Row className="reschedulecard-history-container">
                <Col md={12}>
                  {this.state.Rescheduledata.map((i, j) => (
                    <>
                      {!isReschedulingLoading && isReschedulingAvailable && (
                        <Row className="reschedulecard-history">
                          <Col md={5} lg={5} className="reschedule-history-data">
                            <div className="">
                              <div className="restitle-history">Booking Details</div>
                              <table className="reschdule-history-table">
                                <tr className="">
                                  <td className="">Booking-Id </td>
                                  <td className="">:</td> <td className="">{i.BookingId}</td>
                                </tr>
                                <tr className="">
                                  <td className="">Boat </td>
                                  <td className="">:</td> <td className="">{i.BoatType + " " + i.SeaterType}</td>
                                </tr>
                                <tr className="">
                                  <td className="">Old Date</td> <td className="">:</td>
                                  <td className="">{i.BookingOldDate.split(" ")[0]}</td>
                                </tr>
                                <tr className="">
                                  <td className="">Payment</td> <td className="">:</td>
                                  <td className="">{i.PaymentName}</td>
                                </tr>
                              </table>
                            </div>
                          </Col>
                          <Col md={1} lg={1} className="history-arrow-block">
                            <div className="history-svg-arrow">
                              <FaArrowCircleRight size="35px" style={{ color: "#1F5748", opacity: "0.8" }} />
                            </div>
                          </Col>
                          <Col md={5} lg={5} className="reschedule-history-data">
                            <div className="">
                              <div className="restitle-history">Rescheduling Details</div>
                              <table className="reschdule-history-table">
                                <tr className="">
                                  <td className="">Booking-Id </td>
                                  <td className="">:</td> <td className="">{i.BookingId}</td>
                                </tr>
                                <tr className="">
                                  <td className=""> Booking pin</td> <td className="">:</td>
                                  <td className="">{i.BookingPin}</td>
                                </tr>
                                <tr className="">
                                  <td className="">New Date</td> <td className="">:</td>
                                  <td className="">{i.BookingNewDate.split(" ")[0]}</td>
                                </tr>

                                <tr className="">
                                  <td className="">Charge</td> <td className="">:</td>
                                  <td className="">₹ {i.RescheduledTotalCharge}</td>
                                </tr>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </>
          </div>
        </div>
      </div>
    );
  }
}

export default RescheduledHistory;
